import React from "react";
import { Link } from "react-router-dom";
import NetworkGlobe from "./NetworkGlobe";

/**
 * For Run Clubs — copy + CTA on the left, 3D rotating globe of every metro
 * the RunCards network serves on the right. Globe is lazy-mounted (see
 * NetworkGlobe) so its three.js bundle never blocks initial load.
 */
const ForRunClubsSection = () => {
  return (
    <section className="bg-runcards-background px-4 py-8 sm:px-6 sm:py-10">
      <div className="mx-auto max-w-7xl">
        <div
          className="grid items-center gap-10 overflow-hidden rounded-3xl p-6 sm:p-8 md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] md:gap-12 md:p-12"
          style={{ backgroundColor: "#1a1a1a" }}
        >
          {/* Copy + CTA */}
          <div className="flex flex-col items-center text-center md:items-start md:text-left">
            <p className="mb-3 font-runcards-bold text-[11px] uppercase tracking-[0.32em] text-runcards-accent">
              For run clubs
            </p>
            <h2 className="mb-4 font-runcards-black text-[clamp(1.75rem,4vw,2.75rem)] leading-[1.05] tracking-[-0.02em] text-white">
              Your club, on the map.
            </h2>
            <p className="mb-7 max-w-xl font-runcards text-runcards-md text-white/70 sm:text-runcards-lg">
              Create runs, promote them, manage registrations, message your
              members, and track who shows up — all in one place. Free for clubs.
            </p>
            <Link
              to="/auth"
              className="rc-glass inline-flex items-center justify-center rounded-runcards-lg px-6 py-3 font-runcards-bold text-runcards-sm transition-transform hover:scale-[1.02] sm:text-runcards-md"
            >
              Get started — it's free
            </Link>
          </div>

          {/* 3D globe — every RunCards metro plotted at real lat/lng. */}
          <div className="relative w-full">
            <div className="relative aspect-square w-full overflow-hidden rounded-2xl bg-gradient-to-br from-[#0a0a0a] via-[#11131a] to-[#0a0a0a] sm:aspect-[4/3]">
              {/* Brand-accent ambient glow behind the sphere. */}
              <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_55%,rgba(111,174,135,0.18),transparent_60%)]" />
              <NetworkGlobe />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForRunClubsSection;
